// extracted by mini-css-extract-plugin
export default {"mainSection":"som-testing-step-1_mainSection__I2qXt"};